import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */

export const _frontmatter = {
  "title": "Getting Started",
  "order": 1
};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const PageContent = makeShortcode("PageContent");
const LeadParagraph = makeShortcode("LeadParagraph");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <PageContent componentName="getting_started" type="api_intro" mdxType="PageContent">
      <LeadParagraph mdxType="LeadParagraph">
  Install the Magma component library, and start using Cengage-themed,
  accessible components in your application.
      </LeadParagraph>
      <p>{`For more information, including information on contributing to Magma and running the project locally, visit the `}<a parentName="p" {...{
          "href": "https://github.com/cengage/react-magma"
        }}>{`Github Repo`}</a>{`.`}</p>
      <h2>{`Installation`}</h2>
      <h3>{`Setup Requirements`}</h3>
      <ol>
        <li parentName="ol">{`Your project needs to be running `}<strong parentName="li">{`React v17`}</strong></li>
        <li parentName="ol">{`Icons must be installed as a peer dependency`}</li>
      </ol>
      <h3>{`Install the Component Library`}</h3>
      <p>{`Install the Magma component library with `}<inlineCode parentName="p">{`npm`}</inlineCode>{`.`}</p>
      <pre><code parentName="pre" {...{
          "className": "language-sh",
          "metastring": "title noRender noCodeSandbox",
          "title": true,
          "noRender": true,
          "noCodeSandbox": true
        }}>{`npm install --save react-magma-dom
`}</code></pre>
      <p>{`Install peer dependencies`}</p>
      <pre><code parentName="pre" {...{
          "className": "language-sh",
          "metastring": "title noRender noCodeSandbox",
          "title": true,
          "noRender": true,
          "noCodeSandbox": true
        }}>{`npm install --save \\
    "@emotion/react@11.13.0" \\
    "@emotion/styled@11.13.0" \\
    "react@17.0.2" \\
    "react-dom@17.0.2" \\
    "react-magma-icons@3.2.5"
`}</code></pre>
      <h2>{`Icons Only`}</h2>
      <p>{`The Icon library is not dependent on react-magma being used. `}<inlineCode parentName="p">{`react-magma-icons`}</inlineCode>{` can be used independently by installing the package as a dependency in your project.`}</p>
      <pre><code parentName="pre" {...{
          "className": "language-sh",
          "metastring": "title noRender noCodeSandbox",
          "title": true,
          "noRender": true,
          "noCodeSandbox": true
        }}>{`npm install --save react-magma-icons
`}</code></pre>
      <h2>{`Known Issues`}</h2>
      <ol>
        <li parentName="ol"><inlineCode parentName="li">{`Legacy context API has been detected within a strict-mode tree`}</inlineCode>{` - `}<a parentName="li" {...{
            "href": "https://github.com/JedWatson/react-select/pull/3487"
          }}>{`https://github.com/JedWatson/react-select/pull/3487`}</a></li>
      </ol>
    </PageContent>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      